import { ApiData } from '@cawita/core-front/api';
import { User } from './user.model';

export class NotificationCheck extends ApiData {
    user: User;
    lastCheck: Date;
    creationDate: number;
    lastUpdateDate: number;
}